import React, { useEffect, useState, useRef } from "react";
import style from "../style/Sidebar.module.scss";
import end_logo from "/end_logo.svg";
import end_logo_name from "/end_logo_name.svg";
import styled from "styled-components";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Container = styled.div`
  /* position: relative; */
  .sidebarButton {
    position: absolute;
    top: 10px;
    right: -18px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    transform: ${({ isOpen }) => (isOpen ? `initail` : `rotate(180deg)`)};
    &:hover {
      border: 1px #000 solid;
    }
  }
  .logoContent {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    .imgContent {
      display: flex;
      img {
        max-width: 100%;
        height: auto;
      }
      cursor: pointer;
      transition: all 0.3s;
      transform: ${({ isOpen }) => (isOpen ? `scale(0.6)` : `scale(0.8)`)};
    }
    .logoName {
      width: 150px;
      display: ${({ isOpen }) => (isOpen ? `block` : `none`)};
    }
  }
  .linkContainer {
    margin: 8px 0;
    padding: 0 15%;
    .oneFloor {
      display: flex;
      align-items: center;
      .linkIcon {
        padding: 10px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          color: #057fff;
          font-size: 12px;
        }
      }
      .floorName {
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        .floorBtnIcon {
          cursor: pointer;
          .icon {
            color: #ccc;
          }
        }
      }
    }
    .oneFloorChild {
      .childContents {
        padding: 10px;
        margin-left: 30px;
        font-size: 14px;
        border-radius: 8px;
        .Links {
          text-decoration: none;
          color: #057fff;
        }
      }
    }
  }
`;

const FloorBtnIcon = styled.div`
  transition: all 0.3s;
  transform: ${({ isNewOpen }) => (isNewOpen ? `initail` : `rotate(180deg)`)};
`;

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const containRef = useRef(null);
  const [open, setOpen] = useState([]);
  const [backUpOpen, setBackUpOpen] = useState(false);
  const [authData, setAuthData] = useState(null);
  const changeState = () => {
    setSidebarOpen(!sidebarOpen);
  };
  // console.log(open);
  const click = (RowId, Url) => {
    if (Url != null) {
      navigate(Url);
    } else {
      if (open.includes(RowId)) {
        const newOpen = open.filter((v) => {
          return v !== RowId;
        });

        setOpen(newOpen);
      } else {
        const newOpen = [...open, RowId];
        setOpen(newOpen);
      }
    }
  };

  useEffect(() => {
    const CurrentAuthData = JSON.parse(localStorage.getItem("auth"));
    console.log(CurrentAuthData);
    setAuthData(CurrentAuthData);
    CurrentAuthData?.Menu?.map((v, i) => {
      const targetItem = v.ChildMenus?.find((v) => v.Url === location.pathname);

      if (targetItem != undefined) {
        //click(targetItem.RowId);
        const newOpen = [...open, v.RowId];
        setOpen(newOpen);
      }
    });
  }, []);

  function handleOpen() {
    if (window.innerWidth <= 1200) {
      setBackUpOpen(true);
    } else {
      setBackUpOpen(false);
    }
  }

  useEffect(() => {
    handleOpen();
    window.addEventListener("resize", handleOpen);
    return () => {
      window.addEventListener("resize", handleOpen);
    };
  }, []);
  // console.log(authData);

  return (
    <>
      <Container
        className={
          sidebarOpen ? `${style.sidebarActive_body}` : `${style.sidebar_bady}`
        }
        isOpen={sidebarOpen}
      >
        <div
          className={`sidebarButton ${style.sidebarBtn}`}
          onClick={changeState}
        >
          <i
            className="fa-solid fa-arrow-left"
            style={{ color: "#E0E0E0" }}
          ></i>
        </div>
        <div className="logoContent">
          <div className="imgContent">
            <img src={end_logo} alt="" className={style.logo} />
          </div>
          <img src={end_logo_name} className="logoName" />
        </div>
        <div>
          {authData?.Menu?.map((v, i) => {
            const { ChildMenus, Icon, Name, RowId, Url } = v;
            return (
              <div key={RowId} className="linkContainer">
                <div className="oneFloor">
                  <div className="linkIcon">
                    <i className={`fa-solid ${Icon} icon`}></i>
                  </div>
                  {sidebarOpen && (
                    <div
                      className="floorName"
                      onClick={() => {
                        click(RowId, Url);
                      }}
                    >
                      {Name}
                      {ChildMenus ? (
                        <FloorBtnIcon
                          className="floorBtnIcon"
                          isNewOpen={open?.includes(RowId)}
                        >
                          <i className="fa-solid fa-chevron-up icon"></i>
                        </FloorBtnIcon>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
                <div className="oneFloorChild">
                  {sidebarOpen &&
                    open.includes(RowId) &&
                    ChildMenus?.map((v, i) => {
                      const { Name, Url } = v;
                      return (
                        <div
                          className="childContents"
                          key={i}
                          style={{
                            background:
                              Url === location.pathname ? `#f2f2f2` : ``,
                          }}
                        >
                          <Link
                            className="Links"
                            to={Url}
                            onClick={changeState}
                          >
                            {Name}
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
        <div
          style={{
            height: "40px",
            fontSize: "14px",
            position: "absolute",
            bottom: "0px",
            left: "4px",
            borderTop: "1px solid #ccc",
            display: sidebarOpen ? "flex" : "none",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <Link
            to={"/PrivacyPolicy"}
            target="_blank"
            style={{ color: "#252525", textDecoration: "none" }}
          >
            LINE使用宣告&服務條款及隱私權政策
          </Link>
        </div>
      </Container>
      <div
        style={{
          background: "#777777cc",
          width: "100%",
          height: "100vh",
          position: "fixed",
          zIndex: sidebarOpen ? "10" : "99",
          display: sidebarOpen && backUpOpen === true ? "block" : "none",
        }}
        className={style.sidebarBack}
      ></div>
    </>
  );
}

export default Sidebar;
